import {Injectable} from '@angular/core';
import {Store} from '@ngrx/store';
import {ProleisSuppliersState} from '../store.index';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {SuppliersService} from '../../../services/suppliers.service';
import {PositionActions} from './position.index';
import {exhaustMap, map} from 'rxjs/operators';
import {CoreService, DocumentService, ProleisObject} from '@proleis/proleis-rest-client';

@Injectable()
export class PositionEffects {

  constructor(private store: Store<ProleisSuppliersState>, private actions: Actions,
              private suppliersService: SuppliersService, private documentsService: DocumentService, private coreService: CoreService) {
  }

  loadTlPositions$ = createEffect(
    () => {
      return this.actions.pipe(
        ofType(PositionActions.LOAD_TL_POSITIONS),
        exhaustMap(action => {
          const aliasFields = 'SNR=TEILE_OBJECT_ID.TEXT;ACTIVITYICON=PSETYP_ID.CLIENTICON;' +
            'TERMINA=PARENT.MEILENSTEIN_CONT_ID.CHILD[NAME=A-TER].MS_DATUM;CALC_OPEN=OBJECT_ID.CALC_COUNT_OPEN_DELIVERY' +
            ';PSETYPGUID=PSETYP_ID.GUID;DWS_CHANGE_DOCUNAME=DWS_CHANGE_DOCU_ID.NAME';
          return this.suppliersService.getPositions(action.orderId, null, 'tl', null, aliasFields).pipe(
            map(positions => PositionActions.ON_TL_POSITIONS_LOADED_SUCCESS({positions: this.sort(positions)}))
          );
        })
      );
    }
  );

  onTlPositionsLoaded$ = createEffect(
    () => {
      return this.actions.pipe(
        ofType(PositionActions.ON_TL_POSITIONS_LOADED_SUCCESS)
      );
    }, {dispatch: false}
  );

  onTlPositionsLoadedError$ = createEffect(
    () => {
      return this.actions.pipe(
        ofType(PositionActions.ON_TL_POSITIONS_LOADED_ERROR)
      );
    }, {dispatch: false}
  );

  loadBmPositions$ = createEffect(
    () => {
      return this.actions.pipe(
        ofType(PositionActions.LOAD_BM_POSITIONS),
        exhaustMap(action => {
          const aliasFields = 'SNR=TEILE_OBJECT_ID.TEXT;ACTIVITYICON=PSETYP_ID.CLIENTICON;' +
            'TERMINA=PARENT.MEILENSTEIN_CONT_ID.CHILD[NAME=A-TER].MS_DATUM;CALC_OPEN=OBJECT_ID.CALC_COUNT_OPEN_DELIVERY' +
            ';WERKZEUGART=PSE_WERKZEUGART_ID.TEXT;AUSFUEHRUNG=PSE_AUSFUEHRUNG.DESCRIPTION;PSETYPGUID=PSETYP_ID.GUID' +
            ';DWS_CHANGE_DOCUNAME=DWS_CHANGE_DOCU_ID.NAME';
          return this.suppliersService.getPositions(action.orderId, null, 'bm', null, aliasFields).pipe(
            map(positions => PositionActions.ON_LOAD_BM_POSITIONS_SUCCESS({positions: this.sort(positions)}))
          );
        })
      );
    }
  );

  onBmPositionsLoaded$ = createEffect(
    () => {
      return this.actions.pipe(
        ofType(PositionActions.ON_LOAD_BM_POSITIONS_SUCCESS)
      );
    }, {dispatch: false}
  );

  onBmPositionsLoadedError$ = createEffect(
    () => {
      return this.actions.pipe(
        ofType(PositionActions.ON_LOAD_BM_POSITIONS_SUCCESS)
      );
    }, {dispatch: false}
  );

  loadTpPositions$ = createEffect(
    () => {
      return this.actions.pipe(
        ofType(PositionActions.LOAD_TP_POSITIONS),
        exhaustMap(action => {
          const aliasFields = 'SNR=TEILE_OBJECT_ID.TEXT;ACTIVITYICON=PSETYP_ID.CLIENTICON;' +
            'TERMINA=PARENT.MEILENSTEIN_CONT_ID.CHILD[NAME=A-TER].MS_DATUM;CALC_OPEN=OBJECT_ID.CALC_COUNT_OPEN_DELIVERY' +
            ';WERKZEUGART=PSE_WERKZEUGART_ID.TEXT;AUSFUEHRUNG=PSE_AUSFUEHRUNG.DESCRIPTION;PSETYPGUID=PSETYP_ID.GUID' +
            ';DWS_CHANGE_DOCUNAME=DWS_CHANGE_DOCU_ID.NAME';
          return this.suppliersService.getPositions(action.orderId, null, 'tp', null, aliasFields).pipe(
            map(positions => PositionActions.ON_LOAD_TP_POSITIONS_SUCCESS({positions: this.sort(positions)}))
          );
        })
      );
    }
  );

  onTpPositionsLoaded$ = createEffect(
    () => {
      return this.actions.pipe(
        ofType(PositionActions.ON_LOAD_TP_POSITIONS_SUCCESS)
      );
    }, {dispatch: false}
  );

  onTpPositionsLoadedError$ = createEffect(
    () => {
      return this.actions.pipe(
        ofType(PositionActions.ON_LOAD_TP_POSITIONS_ERROR)
      );
    }, {dispatch: false}
  );

  loadPosition$ = createEffect(
    () => {
      return this.actions.pipe(
        ofType(PositionActions.LOAD_POSITION),
        exhaustMap(action => {
          return this.suppliersService.getPosition(action.pboId, action.posId).pipe(
            map(pos => PositionActions.ON_POSITION_LOADED_SUCCESS({position: pos}))
          );
        })
      );
    }
  );

  onPositionLoaded$ = createEffect(
    () => {
      return this.actions.pipe(
        ofType(PositionActions.ON_POSITION_LOADED_SUCCESS)
      );
    }, {dispatch: false}
  );

  onPositionLoadedError$ = createEffect(
    () => {
      return this.actions.pipe(
        ofType(PositionActions.ON_POSITION_LOADED_ERROR)
      );
    }, {dispatch: false}
  );


  loadPmDocuments$ = createEffect(
    () => {
      return this.actions.pipe(
        ofType(PositionActions.LOAD_PM_DOCUMENTS),
        exhaustMap(action => {
          return this.documentsService.getOfficeDocuments(action.objectId, action.aliasFields).pipe(
            map(result => {
              return PositionActions.LOAD_PM_DOCUMENTS_SUCCESS({
                documents: result
              });
            })
          );
        })
      );
    }
  );

  sort(data: ProleisObject[]): ProleisObject[] {
    return data.sort((a, b) => {
      if (a.TEXT < b.TEXT) {
        return -1;
      }
      if (a.TEXT > b.TEXT) {
        return 1;
      }
      return 0;
    });
  }

}
